const translations = {
  "en": {
    "All": "All",
    "All %{var0} foundations are ready. Ed is now fully set up to monitor your finances and deliver timely insights.": "All %{var0} foundations are ready. Ed is now fully set up to monitor your finances and deliver timely insights.",
    "foundations are ready. Ed is now fully set up to monitor your finances and deliver timely insights.": "foundations are ready. Ed is now fully set up to monitor your finances and deliver timely insights.",
    "Got it": "Got it",
    "I can see the whole picture now.": "I can see the whole picture now.",
    "Running": "Running",
    "Setup complete": "Setup complete",
    "Six pieces connected. Nothing about your money is outside the watch any more.": "Six pieces connected. Nothing about your money is outside the watch any more.",
    "What's now running": "What's now running",
    "Your first read lands tomorrow morning. After that I check every day, tell you the same day something moves, and send a short read every two weeks.": "Your first read lands tomorrow morning. After that I check every day, tell you the same day something moves, and send a short read every two weeks."
  },
  "zh-tw": {
    "All": "所有",
    "All %{var0} foundations are ready. Ed is now fully set up to monitor your finances and deliver timely insights.": "所有 %{var0} 基礎設定已完成。Ed 現已完整設定，將為您監控財務狀況並提供即時洞察。",
    "foundations are ready. Ed is now fully set up to monitor your finances and deliver timely insights.": "基礎設定已完成。Ed 目前已完整就緒，將為您監控財務狀況並提供即時洞察。",
    "Got it": "了解",
    "I can see the whole picture now.": "我已掌握整體狀況。",
    "Running": "執行中",
    "Setup complete": "設定完成",
    "Six pieces connected. Nothing about your money is outside the watch any more.": "已連線六項資料。您的所有資金，現在都已納入掌握。",
    "What's now running": "目前執行中",
    "Your first read lands tomorrow morning. After that I check every day, tell you the same day something moves, and send a short read every two weeks.": "您的首份解讀將於明早發送。此後我每天都會持續追蹤，若市場出現變動，當天即會通知您，並每兩週發送一份簡短解讀。"
  }
};

export default translations;
